/**
 * PaceHRM Design System — token reference (Step 1).
 * Source of truth for CSS vars lives in `src/index.css`.
 * Tailwind maps these via `tailwind.config.js`.
 *
 * Ink: near-black `--ds-fg` for headings, labels, buttons, tables; gray `--ds-muted-fg` for secondary text.
 * Brand: PaceHRM teal (#165b5d) + navy (#122d4f) — overridable via product themes
 * (`themes.js` remaps brand CSS vars only; default leaves index.css untouched).
 * Grid: 8pt (spacing 1=4px … 8=32px)
 * Icons (Lucide): sm=16, md=20, lg=24 — strokeWidth 1.75
 */

export const ICON_SIZE = { sm: 16, md: 20, lg: 24 };
export const ICON_STROKE = 1.75;

export const TYPE_SCALE = {
  h1: { size: "1.5rem", line: "2rem", weight: 700 }, // 24/32
  h2: { size: "1.25rem", line: "1.75rem", weight: 600 }, // 20/28
  h3: { size: "1.125rem", line: "1.75rem", weight: 600 }, // 18/28
  h4: { size: "1rem", line: "1.5rem", weight: 600 }, // 16/24
  bodyLg: { size: "1rem", line: "1.5rem", weight: 400 },
  body: { size: "0.875rem", line: "1.25rem", weight: 400 }, // 14/20
  caption: { size: "0.75rem", line: "1rem", weight: 500 }, // 12/16
  small: { size: "0.6875rem", line: "1rem", weight: 500 }, // 11/16
};

export const FONT_WEIGHTS = {
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
};

/** Semantic color roles (see CSS variables). */
export const COLOR_ROLES = [
  "primary",
  "secondary",
  "accent",
  "background",
  "surface",
  "muted",
  "border",
  "success",
  "warning",
  "danger",
  "info",
];

/**
 * Module page layout classes — keep screens on one shell.
 * Full docs: `.cursor/rules/pacehrm-design-system.mdc` + `index.css` `.ds-page-*`.
 */
export const PAGE_LAYOUT_CLASSES = [
  "ds-page",
  "ds-page-shell",
  "ds-page-body",
  "ds-page-aside",
  "ds-page-main",
  "ds-page-content",
  "ds-page-content-flush",
  "ds-page-panel",
  "ds-page-toolbar",
];
